module.exports = __webpack_public_path__ + "img/ic-stats-active.7a5a8a56.svg";